import useConfirm from "./UseConfirm";

const ConfirmationDialog = (props) => {
  // Define the props passed to the component
  const [Dialog, confirmDelete] = useConfirm(
    "Confirm",
    `Are you sure you want to ${
      props.assets == "Vehicle" ? "Unassign Driver of":
      props.assets == "Schedule"
        ? "Delete"
        : props.data.isActive
        ? "deactivate"
        : "activate"
    } ${props.assets} ( ${props.name} )`
  );

  const handleDelete = async (data) => {
    const ans = await confirmDelete();
    if (ans) {
      props.handleStatus(data);
      // statusActive(rowData.row.original, enterpriseName);
    } else {
      /* ... */
    }
  };
  return (
    <>
      {props.assets == "Schedule" ? (
        <img
          src={require("assets/CancelRed.svg").default}
          style={{ cursor: "pointer", marginLeft: "15px" }}
          onClick={() => {
            handleDelete(props.data);
          }}
        ></img>
      ) : (
        <button
          style={{ border: "none", margin: "8px", cursor: "pointer" }}
          onClick={() => {
            handleDelete(props.data);
          }}
        >
          <img
            src={
              require(props.data.isActive
                ? "assets/active.png"
                : "assets/inactive.png").default
            }
            height={"20px"}
            width={"20px"}
          ></img>
        </button>
      )}
      <Dialog />
    </>
  );
};
export default ConfirmationDialog;
